import { IonIcon } from '@ionic/react';
import { arrowBackOutline } from 'ionicons/icons';
import React from 'react';

import { useOnboarding } from '../../context';
import { OnboardingParamsTool } from '../../utils/paramsTool';

import {
  NavigationBackButtonStyles,
  NavigationProgressBarStyles,
  NavigationProgressStyles,
  NavigationRangeStyles,
} from './NavigationRange.styles';

interface HeadlineOptions {
  onBack?: () => void;
}

export const NavigationRange: React.FC<HeadlineOptions> = ({ onBack }) => {
  const { steps, wizard } = useOnboarding();
  const stepIndex = wizard.stepIndex();

  const handleBack = (): void => {
    if (onBack) {
      onBack();
      return;
    }

    const prevStep = Object.keys(steps)[stepIndex - 1];
    if (prevStep) {
      OnboardingParamsTool.setParam('step', prevStep);
      wizard.goToStep(prevStep);
    }
  };

  const needToRenderBackButton =
    stepIndex !== 0 && stepIndex < Object.keys(steps).length - 2;

  const calculatePrevStepWidth = (): number => {
    const prevStepKey = wizard.history[wizard.history.length - 2];
    const prevStepIndex = Object.keys(steps).findIndex(
      (key) => key === prevStepKey,
    );

    if (prevStepIndex === -1) {
      return 3;
    }

    const prevStepWidth = Math.round(
      (prevStepIndex / (Object.keys(steps).length - 1)) * 100,
    );

    if (prevStepWidth === 0) {
      return 3;
    }

    if (prevStepWidth >= 100) {
      return 100;
    }

    return prevStepWidth;
  };

  const prevstepWidth = calculatePrevStepWidth();

  const calculateAnimationWidth = (): number => {
    const animationWidth = Math.round(
      (stepIndex / (Object.keys(steps).length - 1)) * 100,
    );

    if (animationWidth === 0) {
      return 3;
    }

    if (animationWidth >= 100) {
      return 100;
    }

    return animationWidth;
  };

  const animationWidth = calculateAnimationWidth();

  return (
    <NavigationRangeStyles>
      <div className="onboarding-navigation__container">
        {needToRenderBackButton && (
          <NavigationBackButtonStyles onClick={handleBack}>
            <IonIcon icon={arrowBackOutline} />
          </NavigationBackButtonStyles>
        )}

        <NavigationProgressStyles>
          <NavigationProgressBarStyles
            initial={{
              width: `${prevstepWidth}%`,
            }}
            animate={{
              width: `${animationWidth}%`,
            }}
          />
        </NavigationProgressStyles>
      </div>
    </NavigationRangeStyles>
  );
};
